import { render, staticRenderFns } from "./BaseGaugeCard.vue?vue&type=template&id=1f3615fe&scoped=true&"
import script from "./BaseGaugeCard.vue?vue&type=script&lang=js&"
export * from "./BaseGaugeCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseGaugeCard.vue?vue&type=style&index=0&id=1f3615fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3615fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
